/* eslint-disable */
//@ts-nocheck
import { useLocation } from "@remix-run/react";
import { useEffect, useState } from "react";
import { GTMDataLayer } from "~/services/gtm-datalayer";

function gtm(GTMAppId: string) {
	window["dataLayer"] = window["dataLayer"] || [];
	window["dataLayer"].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
	const script = document.createElement("script");
	script.src = `https://www.googletagmanager.com/gtm.js?id=${GTMAppId}`;
	script.async = true;
	document.head.appendChild(script);
}
export function useGtm(GTMAppId?: string) {
	const [isHydrated, setIsHydrated] = useState(false);
	const location = useLocation();
	useEffect(() => {
		setIsHydrated(true);
	}, []);
	useEffect(() => {
		if (!isHydrated) return;
		if (!GTMAppId) return;
		gtm(GTMAppId);
	}, [GTMAppId, isHydrated])

	useEffect(() => {
		if (!isHydrated) return;
		if (!GTMAppId) return;
		void GTMDataLayer.trackPageView(location);
	}, [location]);
}